var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginAccount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 84C22 86.7614 24.2386 89 27 89H53C55.2091 89 57 87.2091 57 85V85C57 82.7909 55.2091 81 53 81H22V84Z",
    fill: "#242862"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 81V57H22V81H30Z",
    fill: "#242862"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 16C22 13.2386 24.2386 11 27 11H53C55.2091 11 57 12.7909 57 15V15C57 17.2091 55.2091 19 53 19H22V16Z",
    fill: "#242862"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30 19V39C30 41.2091 28.2091 43 26 43V43C23.7909 43 22 41.2091 22 39V19H30Z",
    fill: "#242862"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 53C1 50.2386 3.23858 48 6 48H37V59H6C3.23858 59 1 56.7614 1 54V53Z",
    fill: "#242862"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52 53.5L36.25 70.3875L36.25 36.6125L52 53.5Z",
    fill: "#242862"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 12L63 2V97L96.5 87V12Z",
    fill: "url(#paint0_linear_2_62)",
    stroke: "url(#paint1_linear_2_62)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_62",
    x1: 79.75,
    y1: 2,
    x2: 79.75,
    y2: 97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0999DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25255E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_62",
    x1: 79.75,
    y1: 2,
    x2: 79.75,
    y2: 97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#089ADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25294E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginAccount);
export default __webpack_public_path__ + "static/media/login-account.4ac48ccf5be0f3f9fb62c8d923250de0.svg";
export { ForwardRef as ReactComponent };